var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"material-icons",class:_vm.type,style:(_vm.styles)},[_vm._v("\n  "+_vm._s(_vm.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }